import { ClientConfig } from '../config/ClientConfig'
import { HttpService } from './http-service'
import { SocialLiveCasinoLiveStats } from '../redux/social-live-casino/LiveStatsState'
import { mapV3ToLiveStats, V3LiveTableState } from '../redux/social-live-casino/LiveStatsV3Mapper'

export async function getLaunchUrl(coinType: 'SC' | 'GC', gameId: string, gameProviderId: string, userId: number): Promise<{ launchUrl: string }> {
    const launchUrl = new URL('/gap/player/launch', ClientConfig.SLOTS_EXTERNAL_API_URL)
    launchUrl.searchParams.set('coinType', coinType)
    launchUrl.searchParams.set('gameId', gameId)
    launchUrl.searchParams.set('gameProviderId', gameProviderId)
    const isMobile = window.matchMedia('(max-width: 767px)').matches
    launchUrl.searchParams.set('isMobile', `${isMobile}`)

    return await HttpService.get<{ launchUrl: string }>(launchUrl.toString(), { authenticate: true })
}

export type SocialLiveCasinoLiveStatsApiResponse = {
    readonly results: { [key: string]: SocialLiveCasinoLiveStatsApiResult };
}

export type SocialLiveCasinoLiveStatsApiResult = {
    readonly type:               string;
    readonly gameId:             string;
    readonly gameName:           string;
    readonly playerCount:        number | null;
    readonly limits:             Limits | null;
    readonly assumedType:        string;
    readonly lastRoundResult?:   LastRoundResult;
    readonly seatsAvailability?: boolean[] | null;
}

type LastRoundResult = {
    readonly dealerCards?: string[] | null;
    readonly lastWinners?: Winner[] | LastWinner [] | null;
    readonly lastNumbers?: number[] | null;
}

type Winner = { score: number, winner: LastWinner}

type LastWinner = 'banker' | 'player' | 'tie';

type Limits = {
    readonly XSD: number;
    readonly XGC: number;
}

const LIVE_STATS_V3_PATH = '/gap/social-live-casino/v3/live-stats'

export async function getLiveStats(): Promise<SocialLiveCasinoLiveStats> {
    const response = await HttpService.get<{ tables: V3LiveTableState[] }>(LIVE_STATS_V3_PATH, { authenticate: true })
    return mapV3ToLiveStats(response.tables)
}
